"use client";

import { create } from "zustand";

export type ProfilePreviewState = "hidden" | "hover" | "pinned";

export interface ProfilePreviewAnchor {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface ProfilePreviewStore {
  state: ProfilePreviewState;
  userId: string | null;
  username: string | null;
  anchor: ProfilePreviewAnchor | null;
  open: (params: {
    userId?: string | null;
    username?: string | null;
    anchor: ProfilePreviewAnchor;
  }) => void;
  close: () => void;
  setHover: () => void;
  setPinned: () => void;
  setAnchor: (anchor: ProfilePreviewAnchor) => void;
}

export const useProfilePreviewStore = create<ProfilePreviewStore>((set) => ({
  state: "hidden",
  userId: null,
  username: null,
  anchor: null,

  open: ({ userId, username, anchor }) =>
    set({
      state: "hover",
      userId: userId ?? null,
      username: username ?? null,
      anchor,
    }),

  close: () =>
    set({
      state: "hidden",
      userId: null,
      username: null,
      anchor: null,
    }),

  setHover: () => set((s) => (s.state === "pinned" ? s : { state: "hover" })),

  setPinned: () => set({ state: "pinned" }),

  setAnchor: (anchor) => set({ anchor }),
}));
